import React from "react";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

const BasicCard = (props) => {
    return(
        <Card sx={{ width: props.width, marginTop: '10px',marginLeft: 0, marginRight: 0}}>
            <CardContent>
                <Typography variant="h4" component="div">
                    {props.title}
                </Typography>
                {props.content}
            </CardContent>
            <CardActions>
                {props.buttons}
            </CardActions>
        </Card>
    );
}
export default BasicCard